import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { api } from "@/api";
import { errorMessage } from "@/api/client";
import { Layout } from "./Layout";
import { ErrorBanner, Spinner } from "./ui";

export function AccessDenied() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-2xl font-semibold">Access denied</h1>
        <p className="text-neutral-600">
          Access denied - ask to be added to the Curse Okta group.
        </p>
      </div>
    </div>
  );
}

export function RequiresAccess() {
  const me = useQuery({
    queryKey: ["me"],
    queryFn: api.me,
    retry: false,
  });

  if (me.isPending) return <Spinner />;
  if (
    (me.isError &&
      isAxiosError(me.error) &&
      me.error.response?.status === 403) ||
    me.data?.allowed === false
  ) {
    return <AccessDenied />;
  }
  if (me.isError) {
    return <ErrorBanner message={errorMessage(me.error)} />;
  }
  return <Layout email={me.data.email} />;
}
